import React from "react";
import { createPortal } from "react-dom";
import { Toaster } from "react-hot-toast";
import { colors, fontSize } from "style";

const TOASTER_Z_INDEX = 999999;

const toaster = (
  <Toaster
    position="top-center"
    reverseOrder={false}
    gutter={8}
    containerClassName="global-toast-container"
    containerStyle={{
      zIndex: TOASTER_Z_INDEX,
    }}
    toastOptions={{
      duration: 5000,
      style: {
        background: colors.purpleRainDark2,
        color: "#fff",
        fontSize: fontSize.small,
        fontWeight: 500,
        boxShadow: "0 1px 3px 0 rgba(85, 76, 197, 0.16)",
        zIndex: TOASTER_Z_INDEX,
      },
      // Default options for specific types
      success: {
        duration: 3000,
        theme: {
          primary: "green",
          secondary: "black",
        },
      },
    }}
  />
);

const Toast = () => {
  if (typeof document === "undefined") return toaster;

  return createPortal(toaster, document.body);
};

export default Toast;
